//= ============================================================================
// Dynamic form
//= ============================================================================

import '../../../vendor/waypoints.min';
import '../init/autocomplete';

window.Reverb = window.Reverb || {};

(function (global) {
  Reverb.Listing = Reverb.Listing || {};
  // This is a temporary home that needs to be decomposed into individual modules
  Reverb.Listing.General = (function () {
    let startedForm = false;
    let hasCustomTitle = false;

    function bindEndListingChangeHandler() {
      $('[id^="end-listing-reason-"]').change(function () {
        const other = $(this).parents('.dialog').find('#other_reason');
        if ($(this).val() === 'other') {
          toggleInput(other);
        } else if (other.is(':visible')) {
          toggleInput(other);
        }
      });
    }

    function bindHintFadeIns() {
      $('.hint-faded').waypoint(function (direction) {
        fadeInOpacity($(this));
      }, { offset: 500 });

      $('.hint-btm').waypoint(function (direction) {
        fadeInOpacity($(this));
      }, { offset: 650 });

      $('.g-container').find(':input').focus(function () {
        const hint = $(this).closest('.g-container').find('.hint-faded');
        fadeInOpacity(hint);
      });
    }

    function stickyBuyButton() {
      $('.sticky-buy-trigger').waypoint((direction) => {
        if (direction === 'down') {
          $('.sticky-buy').addClass('sticky-buy--active');
        }

        if (direction === 'up') {
          $('.sticky-buy').removeClass('sticky-buy--active');
        }
      });
    }

    function fadeInOpacity($element) {
      $element.animate({ opacity: 1.0 });
    }

    function setLastModuleMargin() {
      $('.g-container.mb-4').last().css('margin-bottom', '28px');
    }

    function toggleInput($inputContainer) {
      $inputContainer.toggle();
      $inputContainer.toggleClass('required');
      const input = $inputContainer.find('input');
      input.toggleClass('required');
      input.prop('disabled', !input.prop('disabled'));
      input.prop('required', !input.prop('required'));
    }

    function isNotEmptyString(string) {
      if (string === undefined) {
        return false;
      }

      const emptyStringPattern = /^\s*$/;
      return !emptyStringPattern.test(string);
    }

    function shouldAutoGenerateItemTitle() {
      return isNewRecord() && !hasCustomTitle;
    }

    function recordTitleCustomization() {
      $(document).on('keydown', '#product_title', () => {
        hasCustomTitle = true;
      });
    }

    function autoGenerateItemTitle() {
      $(document).on('blur listing.autocomplete.selected', '#product_make, #product_model, #product_year, #product_finish', () => {
        if (shouldAutoGenerateItemTitle()) {
          const nonEmptyTitleAttributes = $.grep([
            $('#product_make').val(),
            $('#product_model').val(),
            $('#product_year').val(),
            $('#product_finish').val(),
          ], isNotEmptyString);

          const title = $.trim(nonEmptyTitleAttributes.join(' '));

          $('#product_title').val(title);
        }
      });
    }

    function productForm() {
      return $('.listing-editor form');
    }

    function isNewRecord() {
      return productForm().prop('id') == 'new_product';
    }

    function autocompleteForElement($el, lookup) {
      $el.autocomplete({
        lookup,
        minChars: 2,
        onSelect(suggestion) {
          $(this).trigger('listing.autocomplete.selected');
        },
      });
    }

    function init() {
      $('form#new_product input').bind('change keydown', () => {
        if (startedForm) { return; }
        startedForm = true;
      });

      autoGenerateItemTitle();
      recordTitleCustomization();
      bindEndListingChangeHandler();
      bindHintFadeIns();
      stickyBuyButton();
      setLastModuleMargin();
    }

    return {
      init,
    };
  }());

  //= =============================================================================
  // On DOM load
  //= =============================================================================
  $(() => {
    Reverb.Listing.General.init();
  });
}(window));



// WEBPACK FOOTER //
// ./src/components/legacy/listing/general.js